import type { FileRouteTypes } from '@/routeTree.gen.ts';

/** App route `to` values for global shortcuts. Dashboard (ctrl+d) uses `/layouts/$id` with storage id — see `useGlobalShortcuts`. */
export const ROUTE_TO = {
  layouts: '/layouts', // fullPath in routeTree.gen may be `/layouts/`; navigate `to` for index is `/layouts`.
  bargeControl: '/bargeControl',
  cameraControl: '/utils/cameraCheck',
  hybridPower: '/hybrid-power',
  orbitOne: '/orbitOne',
  penViewer: '/penViewer',
  gamepadLayout: '/gamepadLayoutScreen',
  upCycle: '/upCycle',
  utils: '/utils',
  utilsAutomation: '/utils/automation',
  utilsDeviceConfig: '/utils/deviceConfig',
  utilsEventStream: '/utils/eventStream',
  utilsInventory: '/utils/inventory',
  utilsNetworkHealth: '/utils/networkHealth',
  layoutsNew: '/layouts/new',
  settings: '/utils/settings',
  // REMARK: layouts index fullPath in gen types may be '/layouts/'; navigate `to` for index is '/layouts'
} as const satisfies { readonly [key: string]: FileRouteTypes['to'] };
